export default {
  "login-register": "登录/注册",
  "language": "语言",
  "currency": "货币",
  "home-page": "主页",
  "front-page": "头版",
  "attraction": "景点门票",
  "hotel": "酒店",
  "transport": "租车接送",
  "ferry": "渡轮",
  "packages": "旅游配套",
  "customer-service-phone": "客服电话：+65 98809383 或 +65 6438 2811",
  "manage-booking": "管理预订",
  "products": "产品",
  "point-to-point": "私人接送",
  "disposal": "用车",
  "seat-in-coach": "专车接送",
  "express": "跨境巴士",
  "transport-packages": "接送配套",
  "pages": "页面",
  "about-us": "关于我们",
  "contact-us": "联系我们",
  "faq": "常见问题",
  "privacy-policy": "隐私政策",
  "sign-in": "登录",
  "to-your-account": "到你的账户",
  "forget-your-password": "忘记密码？",
  "login": "登录",
  "or": "或",
  "and": "和",
  "no-account-yet": "还没有账户？",
  "sign-up-now": "现在就注册！",
  "loading": "加载中...",
  "forget-password": "忘记密码",
  "send": "发送",
  "sign-up": "注册",
  "info-password-validation": "您的密码必须至少有 6 个字符，并且必须包含至少 1 个小写字母、1 个大写字母、1 个特殊字符（例如：{'@'}$%&*#' ) 和 1 个数字。",
  "by-registering-i-agree-with": "通过注册，我同意",
  "terms-conditions": "条款和条件",
  "of-ace-toures-travel-pte-ltd": "创意旅游私人有限公司",
  "register": "注册",
  "already-have-account": "已经有账户了？",
  "sign-in-now": "现在登录！",
  "register-success": "注册成功",
  "reset-password": "重置密码",
  "reset-code-success": "重置代码成功",
  "reset-code-description": "密码重置成功，请使用新密码登录",
  "go-to-login": "去登录",
  "you-just-one-click-away": "你只需点击一下",
  "to-confirm-email-address": "要确认您的电子邮件地址，请点击按钮",
  "you-account-has-been-activated": "您的帐户已被激活",
  "profile": "个人资料",
  "edit-profile": "编辑个人资料",
  "manage-passengers": "管理乘客",
  "e-wallet": "电子钱包",
  "credit": "信用",
  "name": "名称",
  "username": "用户名",
  "email": "电邮地址",
  "nationality": "国籍",
  "street-address": "街道地址",
  "phone-code": "电话代码",
  "phone-number": "电话号码",
  "edit": "编辑",
  "balance": "余额",
  "code": "代码",
  "date": "日期",
  "type": "类型",
  "order-id": "订单编号",
  "select_currency": "选择货币",
  "period": "期间",
  "select_period": "选择期间",
  "clear": "清除",
  "opening_balance": "期初余额",
  "current_balance": "目前余额",
  "end_balance": "期末余额",
  "month_january": "一月",
  "month_february": "二月",
  "month_march": "三月",
  "month_april": "四月",
  "month_may": "五月",
  "month_june": "六月",
  "month_july": "七月",
  "month_august": "八月",
  "month_september": "九月",
  "month_october": "十月",
  "month_november": "十一月",
  "month_december": "十二月",
  "amount": "金额",
  "base": "基础货币",
  "status": "状态",
  "Top-up": "充值",
  "Trans-Dedu": "交易历史",
  "topup-balance": "充值电子钱包",
  "topup-history": "充值余额",
  "agent-name": "代理名称",
  "bank": "銀行從",
  "note": "注",
  "file": "文件",
  "save": "保存",
  "back": "后退",
  "tour-package": "旅游配套",
  "tour-transfer": "旅游接送",
  "one-way": "单程",
  "round-trip": "往返",
  "next-select-bus": "下一步，选择巴士",
  "next-select-vehicle": "下一步，选择车辆",
  "modify-search": "修改搜索",
  "depart-trip": "出发旅行",
  "return-trip": "回程",
  "filter": "筛选",
  "depart-time": "出发时间",
  "bus-operator": "巴士运营商",
  "amenities": "设施",
  "reset": "重置",
  "reset-filter": "重新筛选",
  "morning": "早上（凌晨00:00 - 上午 11:59）",
  "afternoon": "下午 (12:00 PM - 6:59 PM)",
  "evening": "晚上 (7:00 PM - 11:59 PM)",
  "route": "路线",
  "seat": "座位",
  "fare": "票价",
  "select-seat": "选择座位",
  "no-result-found": "没有找到结果",
  "please-try-another-search": "请尝试其他搜索",
  "pick-up-point": "出发点",
  "drop-off-point": "下车点",
  "payung-sekaki": "Payung Sekaki",
  "air-dingin": "Air Dingin",
  "vehicle-type": "车辆类型",
  "bus": "巴士",
  "car": "汽车",
  "business-partner": "商业伙伴",
  "3m-transport": "3M Transport (Sari Indah)",
  "harapan-jaya": "Harapan Jaya",
  "pahala-kencana": "Pahala Kencana",
  "more-than": "多余",
  "no-of-pax": "人数",
  "image": "图像",
  "luggage-capacity": "行李容量",
  "select": "选择",
  "port-to-city": "港口到城市",
  "city-to-city": "城市到城市",
  "city-to-port": "城市到港口",
  "singapore-to-malaysia": "新加坡到马来西亚",
  "singapore-and-malaysia": "新加坡和马来西亚",
  "porttocity": "港口到城市",
  "citytocity": "城市到城市",
  "citytoport": "城市到港口",
  "singaporetomalaysia": "新加坡到马来西亚",
  "sgptomy": "新加坡到马来西亚",
  "search": "搜索",
  "seating-capacity": "座位容量",
  "terms-and-conditions": "条款和条件",
  "1-ticketing": "1. 票务",
  "ticketing-desc": "我们作为各家航空公司的代理。因此，根据各自航空公司的条款和条件出售机票。 1A. 如果已售出的机票取消/修改/退款，服务费为除了各航空公司收取的费用外，还需支付 50.00 美元*。还需要注意的是，某些机票没有退款价值，或者不能根据航空公司作为销售条件的一部分设定的条件取消/修改。 1B . 如果出现未出现的情况，将从门票的退款价值中扣除 $200.00* 的费用（如果此类门票具有退款价值），以弥补座位的浪费。",
  "2-hotels": "2. 酒店",
  "hotels-desc": "我们代表新加坡海外的多家酒店销售酒店客房。因此适用他们所施加的条款和条件。 2A。如果预订房间未出现，则收取一晚房费。 2B。如果取消/修改已预订的客房，将收取 $50.00* 的费用。请注意，某些酒店可能不接受任何取消/修改客房预订（尤其是在高峰期），在这种情况下，乘客将被无权获得任何退款。",
  "3-visas": "3. 签证",
  "visas-desc": "我们提供各种签证申请服务。根据其复杂程度，会收取服务费。这是大使馆/领事馆自行收取的任何费用之外的费用。",
  "4-travel-insurance": "4. 旅游保险",
  "travel-insurance-desc": "我们销售特别打包的旅行保险。所售保险受保险集团各自保单中规定的条款和条件的约束。强烈建议所有客户购买旅行保险以涵盖旅行取消等领域, 个人行李, 人身事故, 伤害和疾病. 在任何情况下, 本公司均不得被解释为根据合同安全运输客户或其行李和物品的承运人. 我们的工作人员将很乐意协助查询任何旅行保险。",
  "5-tour-packages": "5. 旅游套餐",
  "5a-reservations-deposit-payment": "5A. 预订、押金和付款",
  "reservations-deposit-payment-desc": "预订时需支付总机票费用的 50% 押金。余款需在出发前 14 天支付。本公司不承认任何押金构成旅游、旅行的确认安排或门票。",
  "5b-cancellations-amendments": "5B. 取消/修改",
  "5b-desc-1": "必须以书面形式取消客户确认的预订，以免造成误解。将收取以下费用：对于本公司运营的旅行团，",
  "5b-desc-2": "对于由第三方提供的旅行或组件，例如游轮、酒店、航空公司、汽车租赁、火车等，应根据各自第三方的条款和条件收取取消费用，处理每人每项服务收费 50 新元。",
  "5b-desc-3": "公司旅游团会员取消旅游，请注意本公司是作为服务商的代理。定金或全额付款后，一切安排仍以最终确认为准。如无法确认安排，本公司将尽量在出发前至少2周（团体游及7天及以上游）或1周（6天及以下游）通知客户，并退还如行程取消，将支付旅游费用，本公司不承担任何进一步责任。本公司保留在出发前以任何理由取消任何行程的权利，包括但不限于人数不足参加者。如果公司决定，可以推荐其他旅游安排。",
  "period-of-cancellation-notice": "取消通知期间",
  "cancellation-charges-per-person": "每人取消费用",
  "from-departure-date": "(从出发日期)",
  "hotel-tour-packages": "酒店/旅游套餐",
  "chartered-flights": "包机和机票/游轮/铁路通票/汽车和组合和长途汽车租赁",
  "30-days-and-more": "30 天以上",
  "deposit-non-refundable": "押金不退还",
  "15-to-29-days": "15 到 29 天",
  "75-of-tour-fare": "旅游票价的 75%",
  "100-tour-fare": "100% 旅游票价",
  "14-days-and-below": "14 天及以下",
  "100-of-tour-fare": "100% 的旅游费用",
  "5c-amendments": "5C. 修正案",
  "amendments-desc": "一般修改 客户在确认预订后进行的任何修改（不包括出发日期、旅行类型或机票），公司将收取每人每次修改 S$50* 的管理费。对于出发日期或旅行类型的修改，将收取上述取消费用。公司对行程的修改 公司将努力不对旅游套餐做出任何重大改变。但是，本公司保留在任何时候因不可预见的情况进行细微更改的权利，且不予赔偿，尤其是在旺季期间。",
  "5d-refund": "5D. 退款",
  "refund-desc": "旅游套票退款（不含机票部分） 客户以现金和支票付款，2-4周内以支票形式退还给客户。高峰期退款可能需要大约 6 周。对于客户使用信用卡付款，退款将通过信用卡公司进行，大约需要 4-6 周，高峰期大约需要 2 个月。",
  "6-accomodation": "6. 住宿",
  "accomodation-desc": "如果预订或要求的住宿不可用，我们将尽一切努力寻找另一个类似标准的住宿。",
  "7-seat-rotation": "7. 座椅旋转",
  "seat-rotation-desc": "为方便所有团员，请客人在旅游期间轮换车厢座位安排，请在领队要求时配合/指导。",
  "8-travel-request": "8. 旅行请求",
  "travel-request-desc": "如果对特殊餐食、饮食要求、相邻房间等有任何要求，请在预订时告知本公司。此类要求以确认和供应情况为准。",
  "9-travel-documents": "9. 旅行证件",
  "travel-documents-desc": "客户自行负责确保其国际护照自返回新加坡之日起至少有 6 个月的有效期，以及相关签证、ESTA、疫苗接种和旅行证件公司将尽可能协助乘客获得必要的签证，但不保证使馆/领事馆的批准。",
  "10-responsibilities": "10. 责任",
  "responsibilities-desc": "本公司及其联营公司仅作为运输公司、酒店及酒店的代理人。旅游项目的其他负责人。他们对因旅行证件不当、持有非法物品或违规行为而导致的伤害、损坏、事故、丢失、延误、盗窃、检疫、海关监管、罢工、行程变更、驱逐出境或移民当局拒绝入境不承担任何责任。造成人身或财产。任何损失和费用由客户负责。所有适当的旅行证件均由客户自行负责。本公司保留更改行程、旅行安排、酒店预订等的权利。如有必要或在不可抗力的情况下，本公司保留在出发日期之前以任何理由取消任何旅行的权利，包括人数不足参与者。如果发生这种情况，公司将退还全部款项，而公司不承担进一步的义务。本公司将推荐替代旅游，最好是同一目的地或其他目的地。如果客户决定不接受替代方案，公司将全额退还所有已支付的款项，而无需承担进一步的义务。如果认为任何个人的行为损害或不符合其他乘客和整个旅行团的利益、和谐和福利，本公司也保留要求任何个人退出旅行团的权利。此后，本公司不再对任何此类人承担任何责任。本公司的任何领队/导游或其他雇员或代理人均无权对本公司承担任何责任，且本公司不受任何声明或陈述的约束，除非以书面形式并由本公司管理层签署。本公司保留在未获得客户任何进一步同意的情况下，在与本公司一起游览期间拍摄客户照片和影片以用于宣传册广告或宣传材料的权利。对于客户在旅行期间购买的任何商品，无论商品是否存在质量缺陷、不适合客户的目的、与提供给客户的样品不符或被客户拒收，本公司均不对客户承担任何责任。客户出于任何原因，即使货物是在构成旅游套餐（包括行程）的一部分的商店购买的，或者是旅游服务、他们的导游、仆人、雇员或独立承包商特别推荐的商店，也不是公司或旅游服务对客户购买上述商品的货款承担责任。",
  "about-us-desc": "創意旅游有限公司 是新加坡领先的旅行社之一，成立于 2003 年。我们的董事总经理 Edward Tay 先生在旅游行业拥有 30 多年的经验，专注于产品开发、团队服务和高端直销。近年来，我们在产品开发方面积累了丰富的专业知识，每年平均接待超过100,000名各国游客。经过多年的努力和进步，我们与大中华区、印度支那、印度尼西亚、菲律宾、印度等地的 100 多家领先的商务和旅行社建立了密切的长期合作关系。通过适应和发展以适应社区的需求，并服务于每个人的不同需求和预算。我们的旅游包括豪华旅游、MICE 旅游、旅游规划、会议、MICE 奖励、遗产旅游、学生团体、休闲高尔夫旅游等。我们拥有自己的导游和教练团队，并与酒店经营者、旅游景点和餐厅建立密切的关系。那一年。我们的运营团队负责处理所有酒店、航班、景点、游轮的预订和预订。近年来，我司实现网络化、规模化、品牌化发展战略，让现代出行更加便捷、全面、高效。創意旅游有限公司 以提供专业和优质的服务为宗旨，以多年的经验为国内外客户和行业创造更多惊喜和促销。我们将继续为新加坡繁华的旅游业做出更多贡献，同时成就一个服务与品牌双赢的品牌。我们将是您永远的商业伙伴。",
  "contact-us-desc": "我们期待收到您的来信，请注意，我们至少需要 2x24 小时才能与您联系。谢谢你。",
  "Reach Out": "联系我们",
  "We are looking forward for your contact, please kindly note that it would take at least 2x24 hours for us to reach you. Thank you.": "我们期待收到您的来信，请注意，我们至少需要 2x24 小时才能与您联系。谢谢你。",
  "Opening Hours": "营业时间",
  "Monday - Friday 09:00 AM - 10:00 PM SGT": "周一至周五上午 9:00 至晚上 10:00（新加坡标准时间）",
  "Saturday 12:00 PM - 06:00 PM SGT": "星期六 12:00 PM - 18:00 PM（新加坡标准时间）",
  "Sunday 12:00 PM - 06:00 PM SGT": "周日 12:00 PM - 18:00 PM（新加坡标准时间）",
  "contact-name": "联系人姓名",
  "contact-email": "联系邮箱",
  "contact-phone": "联系电话",
  "submit": "提交",
  "privacy-policy-desc-1": "您的隐私对我们很重要。",
  "privacy-policy-desc-2": "您的信息将仅用于此请求的目的，不会用于任何其他目的。",
  "hello": "你好,",
  "hello-please": "你好，请",
  "signup-cap": "注册",
  "login-cap": "登录",
  "where to or what trip": "去哪里或去什么旅行",
  "country": "国家",
  "city": "城市",
  "product": "产品",
  "outbound": "外出",
  "package": "配套",
  "booking-history": "预订历史",
  "logout": "登出",
  "tour-packages": "旅游配套",
  "download": "下载",
  "check-this-offer": "查看此报价",
  "recomend-ptp-desc": "有了我们的服务，旅行变得更轻松、更实用。这里有一些点对点的建议，可以帮助您计划旅行。",
  "recomend-disposal-desc": "通过我们的垃圾处理服务，出行将变得轻松，您将在需要时拥有所需的车辆。以下是一些推荐的位置。",
  "recomend-sic-desc": "享受更舒适、灵活的出行方式。我们的服务让您轻松游览城市，开始新的一天。这里推荐一些 SIC 的热门路线。",
  "recomend-express-desc": "使用方便，价格实惠，轻松穿梭于世界各个城市之间。这里有一些受欢迎的快递路线。",
  "keyword-tour-packages": "关键词（搜索活动或景点）",
  "minimum-sic": "SIC 的最低购买人数为 2 人。",
  "boarding-point": "接送地点",
  "deparature-date": "出发日期",
  "return-date": "返回日期",
  "pickup-date": "接客日期",
  "pickup-time": "接客时间",
  "pickup-point": "接客地点",
  "hours": "小时",
  "point option": "私人转移选项",
  "deparature-time": "出发时间",
  "return-time": "返回时间",
  "destination": "下车地点",
  "order-history": "订单历史",
  "filter-by": "过滤",
  "all-products": "所有产品",
  "cruise": "邮轮",
  "all": "全部",
  "verifying": "验证中",
  "completed": "已完成",
  "expired": "已到期",
  "cancelled": "已取消",
  "trips-found": "搜到...行程",
  "start-from": "从...开始",
  "instant": "立刻确认",
  "currently-there-are-no-result-for-this-timing": "目前没有这个时间的搜索结果",
  "proceed-one-way": "继续单程",
  "proceed-one-way-only": "继续单程",
  "continue-transaction": "继续订单",
  "continue": "继续",
  "go-to-departtrip": "前往去程",
  "go-to-returning-trips": "前往回程",
  "up-to": "至",
  "packages-found": "找到...配套",
  "sorting-here": "在这里排序",
  "highest-price": "最高价",
  "lowest-price": "最低价",
  "available": "可用",
  "occupied": "占据",
  "front-side": "前面",
  "choose-seats-for": "座位",
  "choose-seats-for-desc": "如果适用，请在下一步指定儿童票（2-12 岁）的数量。 2岁不用买票。",
  "total": "全部的",
  "welcome-manage-booking": "欢迎管理我的预订",
  "view-your-booking": "查看您的预订",
  "access-all-booking-details": "查看所有预订详情",
  "booking-reference": "预订参考",
  "view-booking": "查看预订",
  "ace-tours-privacy-policy": "創意旅游隐私政策",
  "ace-tours-privacy-policy-desc": "此数据保护通知（“通知”）列出了創意旅游有限公司（以下称为“我们”，“我们”或“我们的”）可能会收集，使用，披露或以其他方式处理的个人数据，以符合《个人数据保护法》（“PDPA”）。本通知适用于我们拥有或在我们控制的个人数据，包括我们参与的组织拥有的个人数据，这些数据是为了我们的目的收集、使用、披露或处理的。",
  "personal-data": "个人资料",
  "personal-data-desc-1": "如本通知中所用：“客户”是指（a）通过任何方式与我们联系的个人，以了解更多有关我们提供的商品或服务的信息，或者（b）可以或已与我们签订合同我们提供任何商品或服务； “个人数据”是指关于可以识别的客户的数据，无论是否正确：（a）从该数据中； （b）从我们拥有或可能可以访问的其他信息中。",
  "personal-data-desc-2": "根据您与我们互动的性质，我们可能会从您那里收集的一些个人数据示例包括您的姓名和身份信息，例如您的nric号码，联系信息，例如您的地址，电子邮件地址或电话号码，国籍，性别，性别，出生日期，婚姻状况，照片和其他视听信息，就业信息和财务信息，例如信用卡号，借记卡号码或银行帐户信息。",
  "personal-data-desc-3": "本通知中使用的其他术语应​​具有PDPA中给出的含义（上下文允许）。",
  "collection-use-and-disclosure-of-personal-data": "收集，使用和披露个人数据",
  "collection-desc-1": "通常，我们可能会在我们的网站上收集，使用，披露，转移和存储您输入的任何信息，或通过各种方式（包括电话，电子邮件，查询或预订）在我们的销售办公室，SMS，传真，邮政和任何平台上提供公司不时使用（集体“平台”）。我们收集的信息包括可以识别您（“个人数据”）的信息，包括但不限于您的姓名，联系电话，邮政和电子邮件地址，联系人偏好，以及您与我们预订，信用卡信息。我们可能还会要求您为您提供有关您参与的旅行偏好，忠诚度，频繁的传单和/或汽车租赁计划的信息个人数据集体称为“个人信息”）。您无需提供请求的个人信息，我们可能会阻止为您提供某些产品或服务。",
  "collection-desc-2": "通常，我们通常不会收集您的个人数据）您（或您的授权代表）已通知收集数据的目的，（ii）您（或您的授权代表）已为这些目的或您的个人数据收集和使用提供书面同意，或（b）PDPA或其他法律允许或要求未经同意或要求收集和使用个人数据。在收集任何其他个人数据之前，我们将寻求您的同意，然后在出于未通知您的目的之前使用您的个人数据（除非法律允许或授权）。",
  "collection-desc-3": "我们可能出于以下任何目的收集和使用您的个人数据：<br> a）在或与您提供的商品和/或服务有关的过程中或与您所要求的商品和/或服务有关； <br> b）验证您的身份； <br> c）响应您的处理，处理和处理查询，请求，申请，投诉和反馈； <br> d）与我们进行管理； <br> e）处理或信贷交易; <br> f）发送有关我们的商品或服务的营销信息，包括通知您我们的营销活动，计划和促销，幸运抽奖，会员资格和奖励计划以及其他促销活动； <br> g）遵守任何适用的法律，法规，实践守则，准则或规则，或协助任何政府和/或监管机构进行的执法和调查； h）您提供的信息的任何其他目的； <br> i）向包括我们的第三方服务提供者和代理商在内的任何无关的第三方传输，以及相关的政府和/或监管机构，无论是在新加坡还是国外，供您使用上述目的； <br> j）与上述有关或与上述有关的任何其他附带业务目的。<br> k）调查和竞赛，我们可能会通过我们不时进行的调查或竞赛来要求与您有关的个人信息。通过调查收集的个人信息将用于监视或改善我们服务的使用和满意度。通过比赛收集的个人信息将用于通知获奖者和奖励奖品。<br> l）可以记录或监控您的电话，以进行质量控制和员工培训。我们将在合理必要的情况下保留呼叫记录，然后删除。在电话期间从您获得的任何个人信息将根据本隐私政策的规定进行处理。",
  "collection-desc-4": "我们希望使您轻松利用与旅行有关的机会。我们这样做的一种方法是，通过电子邮件，短信，传真或帖子向您发送营销消息，其中包含有关您的旅行有关的兴趣和与旅行有关的特殊优惠的信息。请注意，您可以撤回您的同意，以向您发送营销信息。请参阅本隐私政策的选择加入和选择退出政策部分，该部分列出了您如何设置与此类营销信息有关的偏好。",
  "collection-desc-5": "我们可能会披露您的个人数据：<br>（a）在我们在提供您要求的商品或服务方面或与您有关的义务履行义务的情况下需要进行此类披露；或<br>（b）向第三方服务提供商，代理商和其他组织，我们从事上面第6条中列出的任何功能。请注意，这些第三方供应商可以根据需要与您联系，以获取有关您的其他信息，以促进您通过我们进行的旅行预订； <br>（c）管理您的帐户，包括处理账单和提供旅行通知; <br>（d）一般与您沟通； <br>（e）回答您的问题和评论； <br>（f），允许我们在必要时与您联系以获取客户服务； <br >（g）衡量并改善我们的产品，服务和网站的兴趣； <br>（h）在我们的网站上自定义您的经验； <br>（i）作为您的任何奖励和认可计划的一部分奖励您选择加入; <br>（j）解决问题，收取费用或解决问题； <br>（k）以防止潜在的禁止或非法活动； <br>（l）在您制定时执行我们的条款和条件与我们一起预订旅行； （m）在收集点上另外通知您。",
  "collection-desc-6": "我们可以与之共同提供产品或服务的业务合作伙伴。如果您选择接收有关这些产品或服务的信息，我们可能会与这些第三方合作伙伴共享有关您的信息，包括您的个人信息，以便他们可以直接通过电子邮件或发布有关其产品和服务的信息与您联系。",
  "collection-desc-7": "我们希望使您轻松利用与旅行有关的机会。我们这样做的一种方法是，通过电子邮件，短信，传真或帖子向您发送营销消息，其中包含有关您的旅行有关的兴趣和与旅行有关的特殊优惠的信息。请注意，您可以撤回您的同意，以向您发送营销信息。请参阅本隐私政策的选择加入和选择退出政策部分，该部分列出了您如何设置与此类营销信息有关的偏好。",
  "collection-desc-8": "即使在您与我们的关系（例如，根据合同）的关系（例如，在任何方式）之后（包括在适用的情况下，在适用的情况下），即使您与我们的关系（例如，根据合同）已被终止或更改的情况（例如，在适用时，使我们能够根据与您的任何合同执行我们的权利）。",
  "withdrawing-your-consent": "撤回您的同意",
  "withdrawing-desc-1": "您为您提供的个人数据收集，使用和披露的同意将保持有效，直到您以书面形式撤回。您可以撤回同意书，并要求我们停止使用和/或通过以下内容提交您的请求或通过电子邮件向我们的数据保护官提交您的请求，从而在下面提供的联系方式上披露您的个人数据。",
  "withdrawing-desc-2": "收到您撤回同意书的书面请求后，我们可能需要合理的时间（取决于请求的复杂性及其对您与您的关系的影响），以便您的请求进行处理，并向我们通知您的后果加入相同的情况，包括可能影响您对我们的权利和责任的任何法律后果。通常，我们将寻求在收到的十（10）个工作日内处理您的请求。",
  "withdrawing-desc-3": "尽管我们尊重您撤回同意的决定，但请注意，根据您的请求的性质和范围，我们可能无法继续向您提供商品或服务，在这种情况下，我们将在此之前通知您完成您的请求处理。如果您决定取消您的同意撤回，请以书面形式通知我们以上第8条所述的方式。",
  "withdrawing-desc-4": "请注意，撤回同意并不影响我们继续收集，使用和披露个人数据的权利，在未经适用法律允许或要求的情况下进行收集，使用和披露的个人数据。",
  "access-to-and-correction-of-personal-data": "访问和纠正个人数据",
  "access-desc-1": "如果您希望（a）访问我们对您持有的个人数据副本的访问请求，或有关我们使用或披露您的个人数据的方式的信息，或（b）校正请求以正确或更新我们持有的有关您的任何个人数据，您可以通过以下联系详细信息以书面形式或通过电子邮件向我们的数据保护官提交请求。",
  "access-desc-2": "请注意，访问请求可能会收取合理的费用。如果是这样，我们将在处理您的请求之前通知您费用。",
  "access-desc-3": "我们将尽快回答您的请求。如果我们在收到您的请求后的三十（30）天内无法回应您的请求，我们将在我们能够响应您的请求的时间的三十（30）天内以书面形式通知您。如果我们无法为您提供任何个人数据或进行您要求的更正，我们通常会告知您我们无法这样做的原因（除非我们不需要在PDPA下进行此操作）。",
  "protection-of-personal-data": "保护个人数据",
  "protection-desc-1": "为了保护您的个人数据免受未经授权的访问，收集，使用，披露，复制，修改，处置或类似风险，我们引入了适当的管理，物理和技术措施，例如最新的防病毒保护，加密和使用隐私过滤我们的所有存储和传输个人数据，并在内部和我们的授权第三方服务提供商和代理商中披露个人数据，仅在需要的基础上。",
  "protection-desc-2": "但是，您应该知道，没有通过Internet或电子存储方法传输的方法是完全安全的。尽管无法保证安全性，但我们努力保护您的信息的安全性，并不断审查和增强我们的信息安全措施。",
  "accuracy-of-personal-data": "个人数据的准确性",
  "accuracy-desc": "我们通常依靠您（或您的授权代表）提供的个人数据。为了确保您的个人数据是最新，完整和准确的，如果您的个人数据发生了更改，请通过以下信息详细信息通知我们的数据保护官或通过电子邮件通知我们的数据保护官。",
  "retention-of-personal-data": "保留个人数据",
  "retention-desc-1": "只要有必要实现收集的目的，或者根据适用法律的要求或允许，我们就可以保留您的个人数据。",
  "retention-desc-2": "我们将停止保留您的个人数据，或删除与您相关联的方法，一旦合理地假设该保留不再满足收集个人数据的目的，并且没有用于法律或商业目的所需的时间更长。",
  "transfers-of-personal-data": "新加坡以外的个人数据传输",
  "transfers-desc": "我们通常不会将您的个人数据转移到新加坡以外的国家。但是，如果这样做，我们将获得您的同意，以确保您的个人数据继续获得至少与PDPA提供的保护标准。",
  "data-protection-officer": "数据保护官",
  "data-protection-officer-desc": "如果您对我们的个人数据保护政策和程序有任何查询或反馈，或者如果您想以以下方式提出任何请求，则可以联系我们的数据保护官员：",
  "effect-of-notice-and-changes-to-notice": "通知和更改的效果要注意",
  "effect-desc-1": "本通知适用于与我们有关收集，使用和披露您的个人数据的任何其他通知，合同条款和同意条款。",
  "effect-desc-2": "我们可以不时修改此通知，而无需任何事先通知。您可以通过参考该通知最后更新的日期来确定是否进行了任何此类修订。您继续使用我们的服务构成了您对此类变化的认可和接受。",
  "privacy-policy-effective-date": "生效日期：[2020年9月1日]",
  "privacy-policy-last-updated": "最后更新：[2020年9月1日]",
  "price": "价格",
  "addon": "添加",
  "information-details": "详细信息",
  "payment": "支付",
  "departing-info": "出发详情",
  "departing-date": "出发日期",
  "depart-from": "出发地点",
  "duration": "车程时间",
  "arrive-at": "抵达",
  "vehicle-info": "车辆信息",
  "ticket-total-price": "总票价",
  "return-info": "回程详情",
  "return-from": "从...回来",
  "order-summary": "订单摘要",
  "read-more": "阅读更多",
  "payment-info": "支付信息",
  "depart-journey-fare": "去程票价",
  "return-journey-fare": "回程票价",
  "surcharge": "附加费用",
  "admin": "行政",
  "discount": "折扣",
  "promo-code": "折扣码",
  "apply-code": "使用代码",
  "adult": "成人",
  "child": "儿童",
  "infant": "婴儿",
  "senior": "乐龄",
  "pcs": "件",
  "remarks": "备注",
  "enter-your-code": "输入您的代码",
  "Bank Transfer/PayNow": "银行转账/PayNow",
  "E-Wallet": "电子钱包",
  "Visa Card /Master Card": "签证卡 /主卡",
  "refresh": "刷新",
  "proceed-to-payment": "前往支付",
  "payment-is-verifying": "正在验证支付",
  "payment-successful": "支付成功",
  "contact-details": "联系方式",
  "payment-method": "付款方式",
  "person-name": "名字",
  "date-booking": "订购日期",
  "bank-transfer-success-desc": "您的订单正在验证，我们将在收到您的付款后发送确认，并在验证付款后继续确认您的订单。",
  "wallet-success-desc": "成功！您的订单详细信息将在接下来的5-10分钟内发送到您的电子邮件收件箱",
  "back-to-manage-booking": "返回订单管理",
  "back-to-order-history": "返回订单历史",
  "detail-address-pickup": "载客与送达地址详情",
  "pickup-address": "载客地址",
  "search-your-pickup-address": "搜索您的载客地址",
  "drop-off-address": "送达地址",
  "search-your-drop-off-address": "搜索您的送达地址",
  "detail-schedule": "详细时间表和地址",
  "label-detail-schedule": "请输入您的详细地址和详细行程安排",
  "search-your-detail-schedule": "例：在樟宜機場Termimal 3 Entrance 3上車，前往Song Fa Bak Kut Teh Clarke Quay，然後在Clarke Quay - The Central shopping mall入口下車（靠近巴士站），最後下車到Marina Bay Sands Hotel。",
  "contact-person-responsible": "联系人（负责订购的人）",
  "personal-details": "个人资料",
  "title": "称谓",
  "Mr": "先生",
  "Mrs": "女士",
  "Ms": "小姐",
  "Dr": "博士",
  "first-name": "名字",
  "last-name": "姓氏",
  "enter-your-first-name": "输入您的名字",
  "enter-your-last-name": "输入您的姓氏",
  "contact-number": "联系电话",
  "enter-your-phone-number": "输入你的手机号码",
  "email-address": "电邮地址",
  "enter-your-email-address": "舒服您的电邮地址",
  "code-reference": "代码参考",
  "enter-your-code-reference": "在此输入...",
  "passenger": "乘客",
  "dob": "出生日期",
  "enter-your-dob": "输入你的出生日期",
  "pob": "出生地",
  "enter-your-pob": "输入您的出生地",
  "no-passport": "护照号码",
  "enter-your-no-passport": "输入您的护照号码",
  "doe": "效期截止日期",
  "enter-your-doe": "输入效期截止日期",
  "poi": "发照地点",
  "enter-your-poi": "输入发照地点",
  "bank-transfer": "银行转帐",
  "payment-confirmation": "确认支付",
  "upload": "上载",
  "payment-proof": "付款凭证",
  "i-have-paid": "已支付",
  "pickup-detail": "载客地址详情",
  "search-your-pickup-detail": "输入您的详细取货地址",
  "drop-off-detail": "送达地址详情",
  "search-your-drop-off-detail": "输入您的详细下车地址",
  "how-to-top-up": "如何充值",
  "top-up-confirmation": "确认充值",
  "pay-now": "马上支付",
  "required-validation": "{msg}是必填项目",
  "required-validation-row": "{msg} 是第 {row} 行的必填字段",
  "password": "密码",
  "Personal Details - Title": "个人详细信息 - 称谓",
  "Personal Details - First Name": "个人详细信息 - 名字",
  "Personal Details - Last Name": "个人详细信息 - 姓氏",
  "Contact Details - Contact Code": "联系方式 - 联系代码",
  "Contact Details - Contact Code must be choosen": "联系方式 - 必须选择联系代码",
  "Contact Details - Contact Number": "联系方式 - 联系电话",
  "Contact Details - Contact Number cannot be less than 8 digit": "联系方式 - 联系电话不能少于8位数字",
  "Contact Details - Email": "联系方式 - 电子邮件",
  "Please enter a valid email address": "请填写有效的电子邮件地址",
  "Detail Schedule": "详细流程",
  "Pickup Address": "载客地址",
  "Dropoff Address": "送达地址",
  "Pickup detail": "载客地址详情",
  "Dropoff detail": "送达地址详情",
  "Passenger - Title": "乘客-称谓",
  "Passenger - First Name": "乘客 - 名字",
  "Passenger - Last Name": "乘客 - 姓氏",
  "Passenger - Nationality": "乘客 - 国籍",
  "Passenger - Date of birth": "乘客 - 出生日期",
  "Passenger - Place of birth": "乘客 - 出生地",
  "Passenger - No. Passport": "乘客-护照号码",
  "Passenger - Date of expiry": "乘客-效期截止日期",
  "Passenger - Place of issue": "乘客-发照地点",
  "port": "港口",
  "create-password": "创建密码",
  "enter-password": "输入您的密码",
  "confirm-password": "创建密码",
  "enter-confirm-password": "输入您的确认密码",
  "create-account": "创建账户",
  "by-creating-account-you-agree": "创建账户即表示您同意我们的",
  "login-info-1": "预订中的所有客人都必须创建自己的帐户。",
  "login-info-2": "注册您的详细信息并个性化您的旅行，让您完全安心。",
  "price-for": "价格",
  "hour": "小时",
  "car-rental-in": "租车在",
  "showing-available-cars-for": "显示可用汽车",
  "pickup-point-at": "上车点",
  "fullname": "全名",
  'referral-from': '你怎麼認識我們的？',
  "reset-code": "重置代码",
  "code-and-password": "代码和密码",
  "password-must-be-the-same": "密码必须与确认密码相同",
  "(duration)": "(持续时间)",
  "Sunday": "星期日",
  "Monday": "星期一",
  "Tuesday": "星期二",
  "Wednesday": "星期三",
  "Thursday": "星期四",
  "Friday": "星期五",
  "Saturday": "星期六",
  "select-point-type": "选择点类型",
  "Bus": "巴士",
  "Car": "汽车",
  "meet-greet-additional": "迎接和问候附加服务",
  "additional-location": "附加地点",
  "transport add-on-journey-fare": "交通附加行程费用",
  "Passenger 1 - Phone Number": "乘客1 - 电话号码",
  "Passenger 2 - Phone Number": "乘客2 - 电话号码",
  "Passenger 3 - Phone Number": "乘客3 - 电话号码",
  "Passenger 4 - Phone Number": "乘客4 - 电话号码",
  "Passenger 5 - Phone Number": "乘客5 - 电话号码",
  "Passenger 6 - Phone Number": "乘客6 - 电话号码",
  "Passenger 7 - Phone Number": "乘客7 - 电话号码",
  "Passenger 8 - Phone Number": "乘客8 - 电话号码",
  "Passenger 9 - Phone Number": "乘客9 - 电话号码",
  "Passenger 10 - Phone Number": "乘客10 - 电话号码",
  "Passenger 11 - Phone Number": "乘客11 - 电话号码",
  "Passenger 12 - Phone Number": "乘客12 - 电话号码",
  "information-confirmation": "信息确认",
  "information-confirmation-desc": "请检查上下车地址。点击“继续”即表示您确认信息无误，错误信息可能导致处罚。",
  "cancel": "取消",
  "VERIFYING": "验证中",
  "COMPLETED": "已完成",
  "EXPIRED": "已过期",
  "CANCELLED": "已取消",
  "pcs-of-ticket-purchased": "购买的票数量",
  "show": "显示",
  "of": "的",
  "We are looking forward for your contact, please kindly note that it would take at least 2x48 hours for us to reach you. Thank you.": "我们期待您的联系，请注意我们需要至少2x48小时才能回复您。谢谢。",
  "Phone Number cannot be less than 8 digit": "电话号码不能少于8位数字",
  "email-not-found": "未找到电子邮件",
  "fail-update-password": "密码更新失败！",
  "success-change-password": "请检查您的电子邮件以更改密码",
  "Login failed, Username and Password doesn't match": "登录失败，用户名/电子邮件与密码不匹配",
  "Password must have a minimum of 6 characters and must contain at least 1 lower case letter, 1 upper case letter, 1 special character (example: @$%&*#) and 1 number.": "密码必须至少包含6个字符，且至少包含1个小写字母、1个大写字母、1个特殊字符（例如：@$%&*#）和1个数字。",
  "Fullname": "全名",
  "Referral": "推荐",
  "word-of-mouth": "口碑",
  "Password": "密码",
  "Password must be the same as Confirm Password": "密码必须与确认密码相同",
  "email-confirmation-1": "已发送电子邮件至您的邮箱，请按照说明确认您的电子邮件地址。点击",
  "email-confirmation-2": "再次发送确认电子邮件。",
  "resend": "重新发送",
  "resend-email-1": "重新发送电子邮件倒计时",
  "resend-email-2": "秒",
  "trafalgar": "特拉法加",
  "company": "創意旅游有限公司",
  "license-number": "许可证编号",
  "order-detail": "订单详情",
  "ticket-purchased": "购票",
  "user-purchased": "用户购买",
  "created-at": "创建于",
  "expired-at": "过期时间",
  "visit-date": "参观日期",
  "download-e-ticket": "下载电子票",
  "download-invoice": "	下载发票",
  "any-question": "有问题吗？",
  "if-you-are-having-any-question": "如有任何问题，请随时提出",
  "drop-us-a-message": "给我们留言",
  "message": "信息",
  "boarding-country": "出发国家",
  "destination-country": "目的地国家",
  "destination-point": "目的地",
  "pax": "乘客",
  "step-1": "步骤 1",
  "step-2": "步骤 2",
  "step-3": "步骤 3",
  "step-4": "步骤 4",
  "step-5": "步骤 5",
  "step-1-desc": "登录您现有的银行网上银行或手机银行应用程序。",
  "step-2-desc": "在 PayNow 转账屏幕上，请扫描此二维码或输入我们的唯一实体编号 (UEN) (200305848E) 以及转账金额。",
  "step-3-desc": "确认金额正确后再确认转账。",
  "step-4-desc": "不要忘记截图成功页面，如下所示：",
  "step-5-desc": "要验证您的付款，请上传您的收据（截图）。",
  "via-internet-banking": "通过网上银行 / ATM 转账：",
  "dbs-bank": "星展银行（SGD 账户）",
  "account-name": "账户名称",
  "account-no": "账户号码",
  "branch-code": "分行代码",
  "bank-code": "银行代码",
  "swift-code": "Swift 代码",
  "bank-name": "银行名称",
  "note-1-how-to-top-up": "注意：请允许 24 小时处理您的付款。",
  "note-2-how-to-top-up": "已兑换的优惠券严格不予退款。",
  "data": "数据",
  "posted": "已发布",
  "entry": "条目",
  "person": "人",
  "multi-city": "多城市",
  "add-transport": "添加运输",
  "disney": "迪士尼",
  "available_limit": '可用额度',
  "credit_limit": '信用额度',
  "outstanding_balance": '未清余额',
  "overdue_balance": '逾期余额',
  "next_due_date": '下一个到期日',
  "rate": '汇率',
  "debit": '扣账',
  "credit_in_sgd": '以新币扣账',
  "total_amount_due": '总应付金额',
  "walate_balance": '平衡',
  "redeem-code": "兑换码",
  "convert-funds": "资金兑换",
  "from": "从",
  "to": "到",
  "amount_to_convert": "兑换金额",
  "transaction_date": "交易日期",
  "redeem": "兑换",
  "close": "关闭",
  "redeem_code_required": '需要兑换码!',
  "redeem_failed": '哎呀…兑换码失败！请确认您的兑换码是否正确',
  "redeem_success": '耶…兑换码成功！',
  "cancellation": "取消",
  "cancellation_reason": "取消原因",
  "information_cancelation_fee": "取消费用信息",
  "please_provide_cancellation_reason": "请提供取消原因",
  "no_notification": "你沒有任何通知",
  "notification_history_log": "通知（歷史記錄)",
  'read_all': '全部阅读',
  'customer_service_phone': '客服电话',
  'full-name-note': '护照/官方身份证上的姓名。',
  'email-confirmation-note': '您的预订确认和电子票将发送至此电子邮件地址。',
}